<div class="row">
  <div class="col-xxl-9">
    <ngx-transactions-charts></ngx-transactions-charts>
  </div>

  <div class="col-xxl-3">
    <ngx-latest-sales></ngx-latest-sales>
  </div>
</div>